import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { clearRut, formatRut, rutValidate } from "./rutValidate";
import cx from "classnames";
import "./inputRut.scss";
import AsyncCreatableSelect from "react-select/async-creatable";

var InputRut = function InputRut(props) {
  var value = props.value,
      onUserIsExist = props.onUserIsExist,
      selectedUserId = props.selectedUserId,
      _onInputChange = props.onInputChange,
      token = props.token,
      className = props.className,
      title = props.title,
      _props$onlyInput = props.onlyInput,
      onlyInput = _props$onlyInput === void 0 ? false : _props$onlyInput,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      listUsers = _React$useState2[0],
      setListUsers = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isError = _React$useState4[0],
      setIsError = _React$useState4[1];

  var getFullName = function getFullName(user) {
    return user.full_name || [user.name, user.middle_name, user.first_surname, user.second_surname].filter(Boolean).join(" ").trim() || user.name || "";
  };

  var usersOptions = listUsers && listUsers.map(function (someUser) {
    return {
      label: " ".concat(formatRut(someUser.rut), " | ").concat(getFullName(someUser)),
      value: "".concat(someUser.id)
    };
  });

  var filterOptions = function filterOptions(users) {
    return users && users.map(function (someUser) {
      return {
        label: " ".concat(formatRut(someUser.rut), " | ").concat(getFullName(someUser), " "),
        value: someUser.id
      };
    });
  };

  var selectedUser = listUsers === null || listUsers === void 0 ? void 0 : listUsers.find(function (u) {
    return u.id === selectedUserId;
  });
  var currentOption = usersOptions && selectedUserId && usersOptions.find(function (someUser) {
    return parseInt(someUser.value) === selectedUserId;
  }) || (selectedUser ? {
    label: " ".concat(formatRut(selectedUser.rut), " | ").concat(getFullName(selectedUser)),
    value: "".concat(selectedUser.id)
  } : {
    label: formatRut(value || ""),
    value: formatRut(value || "")
  });

  var getUsers = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var inputSearch,
          queryParams,
          url,
          response,
          reponseJson,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inputSearch = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
              queryParams = "?inputSearch=".concat(inputSearch);
              url = "/api/v1/users" + queryParams;
              _context.prev = 3;
              _context.next = 6;
              return fetch(url, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "X-CSRF-Token": token
                }
              });

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.json();

            case 9:
              reponseJson = _context.sent;
              setListUsers(reponseJson);
              return _context.abrupt("return", reponseJson);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14]]);
    }));

    return function getUsers() {
      return _ref.apply(this, arguments);
    };
  }();

  var checkIsValidRut = rutValidate(formatRut(value || ""));
  React.useEffect(function () {
    if (!listUsers) getUsers();
  }, [listUsers]);
  React.useEffect(function () {
    if (value) setIsError(!checkIsValidRut);
  }, [value]);

  var promiseOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(inputValue) {
      var resultUsers, newUsers;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getUsers(inputValue);

            case 3:
              resultUsers = _context2.sent;
              setListUsers(resultUsers);
              newUsers = filterOptions(resultUsers);
              return _context2.abrupt("return", newUsers);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.error("error");
              return _context2.abrupt("return", null);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function promiseOptions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onChange = function onChange(item, _ref3) {
    var action = _ref3.action;

    switch (action) {
      case "clear":
        return _onInputChange("");

      case "select-option":
        var newUserSelected = listUsers.find(function (user) {
          return user.id === parseInt(item.value);
        });
        return onUserIsExist && onUserIsExist(newUserSelected);

      case "create-option":
        return _onInputChange(item.value);
    }
  };

  if (onlyInput) return /*#__PURE__*/React.createElement(AsyncCreatableSelect, {
    value: currentOption,
    defaultOptions: usersOptions,
    isSearchable: true,
    isClearable: true,
    className: cx("cntInputRut_field"),
    loadOptions: promiseOptions,
    placeholder: "Seleccione o escriba Rut",
    onChange: disabled ? undefined : onChange,
    onInputChange: function onInputChange(inputValue, _ref4) {
      var action = _ref4.action;
      if (disabled) return null;
      if (["menu-close", "input-blur", "set-value"].includes(action)) return null;
      return _onInputChange && _onInputChange(clearRut(inputValue));
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx("cntInputRut", isError && "cntInputRut__error", className && className)
  }, /*#__PURE__*/React.createElement("label", {
    className: cx("cntInputRut_label")
  }, title || "Rut"), /*#__PURE__*/React.createElement(AsyncCreatableSelect, {
    value: currentOption,
    defaultOptions: usersOptions,
    isSearchable: true,
    isClearable: true,
    className: cx("cntInputRut_field"),
    loadOptions: promiseOptions,
    placeholder: "Seleccione o escriba Rut",
    onChange: disabled ? undefined : onChange,
    onInputChange: function onInputChange(inputValue, _ref5) {
      var action = _ref5.action;
      if (disabled) return null;
      if (["menu-close", "input-blur", "set-value"].includes(action)) return null;
      return _onInputChange && _onInputChange(clearRut(inputValue));
    }
  }), isError && /*#__PURE__*/React.createElement("p", {
    className: cx("cntInputRut_error")
  }, "El rut es incorrecto"));
};

export default InputRut;